module.exports = __webpack_public_path__ + "media/assets/Menu-d53a71558e8ecfe96d006acc94a57848.svg";